import React from "react";

export default function Annexure1(props) {
  return (
    <div>
      <div className="flex flex-row justify-between items-center">
        <h1 className="text-3xl font-bold mb-6 text-yellow-500">
          Risk Mitigation Guidelines
        </h1>
        <h2 className="text-2xl font-bold mb-6 text-yellow-500">Annexure-1</h2>
      </div>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            For Staff/ coaches/volunteers
          </h2>
          <ul className="space-y-4 mb-1">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure that a list of participants, along with the contact nos.
                of their teacher/ parent is available with concerned Slum Soccer
                staff in advance.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure that Consent Form, duly signed by parent of each
                participant, is available with Slum Soccer in advance. The
                consent form obtained should include consent of parent for
                child’s participation, photography/ videography/ giving first
                aid/ rushing the child to hospital/ acting ‘in loco parentis’
                for safeguarding the child
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Pre-venue check of toilets/ changing facilities to be carried
                out. Participants to be informed of the location of toilets
                before start of the event. Children to be encouraged to go to
                the toilet in groups of 2 or more and only after seeking
                permission of a nominated staff/ coach/ volunteer who should
                keep track of the time that the children go to the toilet and
                investigate any delays.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure that the parents and young adults have contact number of
                the concerned staff/ coach/ volunteer should they become
                disorientated and get lost
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure that school authorities/parents are provided with details
                of transport arrangements, timetable of events and location of
                the events in advance.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure that a head count is taken up routinely and specifically
                when a group of participants board or deboard the transport (if
                arranged by Slum Soccer) OR on arrival to and departure from the
                event.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <div>
                <span className="text-gray-700">
                  Ensure pre-event inspection of facility is conducted.
                </span>
                <br />
                <ul className="space-y-0 mb-4 mt-1">
                  <li className="flex items-start">
                    <span className="text-yellow-500 mr-2 ">○</span>
                    <span className="text-gray-700">
                      Visual inspection of the pitch or playing surface.
                    </span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-500 mr-2 ">○</span>
                    <span className="text-gray-700">Stands and seating</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-500 mr-2 ">○</span>
                    <span className="text-gray-700">Dug-outs</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-500 mr-2 ">○</span>
                    <span className="text-gray-700">Goal posts.</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-yellow-500 mr-2 ">○</span>
                    <span className="text-gray-700">Indoor space.</span>
                  </li>
                </ul>
              </div>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure that participants are communicated appropriately to come
                in appropriate kit (e.g. shin pads, boots, trainers etc.)
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Venue is well lit, including access (stairways etc.). Venue kept
                tidy
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure that identified first aiders have been appointed and
                briefed. Attendees should be aware of the location of First Aid
                Kits and First Aiders.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Staff to be introduced to all attendees and made visible
                throughout the event. All attendees encouraged to speak with a
                designated staff member in the event of any problems or
                concerns.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Staff need to follow standard security procedures and report any
                incidents to the Child Protection Officer
              </span>
            </li>
          </ul>
        </div>

        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <h2 className="text-xl font-bold text-gray-800 mb-4">
            For Slum Soccer
          </h2>
          <ul className="space-y-2 mb-1">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Ensure that all individuals who engage with activities involving
                children and or vulnerable adults are police checked
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Any new member of SS/KVS staff shall be police/criminal
                disclosure checked as part of the recruitment/ Induction process
                (internal). Only staff or volunteers who are checked to be
                appointed to work with children and or vulnerable adults
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                All staff shall complete the Child Safeguarding & Protection
                Policy awareness program.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Slum Soccer’s Child Safeguarding & Protection Policy to shall be
                publicized on its website.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
